import { supabase } from '@/integrations/supabase/client';

export interface CommentFromDB {
  id: string;
  content: string;
  created_at: string;
  user_id: string;
  user_name: string | null;
  user_avatar: string | null;
  username: string | null;
  belt_rank?: string | null;
  is_premium?: boolean;
}

export const postCommentsRepository = {
  async getCommentCount(postId: string): Promise<number> {
    const { data, error } = await supabase.rpc('get_post_comment_count', {
      post_uuid: postId,
    });
    if (error) throw error;
    return data || 0;
  },

  async getComments(postId: string, page: number, pageSize: number): Promise<CommentFromDB[]> {
    const { data, error } = await supabase.rpc('get_post_comments', {
      post_uuid: postId,
      page_size: pageSize,
      page_offset: page * pageSize,
    });
    if (error) throw error;
    return (data || []) as CommentFromDB[];
  },

  async createComment(postId: string, content: string): Promise<void> {
    const { error } = await supabase.rpc('create_post_comment', {
      post_uuid: postId,
      comment_content: content,
    });
    if (error) throw error;
  },

  async deleteComment(commentId: string): Promise<void> {
    const { error } = await supabase.rpc('delete_post_comment', {
      comment_uuid: commentId,
    });
    if (error) throw error;
  },
};
